import { createSelector } from "reselect";
import { AppState } from "../reducers/rootReducer";

const getPaymentButtonLoading = (state: AppState) => state.paymentButton.loading;

export const getPaymentButtonLoadingSelector = createSelector(
  getPaymentButtonLoading,
  (loading) => loading
);